module.exports = __webpack_public_path__ + "img/3-ylqx.21f4c648.jpg";